
function applyClassToCartProperties() {
  // Seleciona todos os elementos de propriedade no carrinho
  const cartOptions = document.querySelectorAll('.cart-item__option');

  console.log("Iniciando aplicação de classes nas propriedades do carrinho...");

  cartOptions.forEach(option => {
    // Obtém o primeiro e o segundo div dentro de .cart-item__option
    const labelElement = option.querySelector('div:nth-child(1)');
    const valueElement = option.querySelector('div:nth-child(2)');

    // Verifica se ambos os elementos foram encontrados
    if (!labelElement || !valueElement) {
      console.log("Elemento label ou value não encontrado dentro de .cart-item__option");
      return; // Pula para o próximo item se algum deles for null
    }

    const label = labelElement.textContent.trim();

    // Log para verificar o rótulo (label) e o valor encontrado
    console.log("Propriedade encontrada:", label);
    console.log("Valor da propriedade:", valueElement.textContent.trim());

    // Verifica o conteúdo do label e aplica uma classe correspondente ao elemento pai (option)
    if (label.includes('discount_bundle:')) {
      option.classList.add('property-discount-bundle');
      console.log("Classe 'property-discount-bundle' adicionada ao elemento pai:", option);
    } else if (label.includes('bundle_group:')) {
      option.classList.add('property-bundle-group');
      console.log("Classe 'property-bundle-group' adicionada ao elemento pai:", option);
    } else if (label.includes('qtdKit:')) {
      option.classList.add('property-qtd-kit');
      console.log("Classe 'property-qtd-kit' adicionada ao elemento pai:", option);
    } else {
      console.log("Nenhuma classe aplicada para:", label);
    }
  });

  console.log("Aplicação de classes nas propriedades do carrinho concluída.");
}
function insertKitDividers() {
   console.log("chamando insert");
  let lastGroup = null;
const cartItems = document.querySelectorAll('cart-item.cart-item');

cartItems.forEach((item, index) => {
  const groupContainer = item.querySelector('.property-bundle-group');
  if (!groupContainer) return;

  const groupValueDiv = groupContainer.querySelector('div:nth-child(2)');
  const groupValue = groupValueDiv?.textContent.trim();

  // Se for o primeiro item ou mudou de grupo, insere divisor
  if (index === 0 || groupValue !== lastGroup) {
    const divider = document.createElement('div');
    divider.className = 'cart-head-kit';
    divider.textContent = 'Produtos do Kit';
    item.parentNode.insertBefore(divider, item);
    lastGroup = groupValue;
  }
});

// Substitui a classe 'cart-item__body' por 'cart-item__kit' nos itens com property-qtd-kit
document.querySelectorAll('cart-item').forEach(item => {
  const hasQtdKit = item.querySelector('.property-qtd-kit');
  if (hasQtdKit) {
    const bodyElement = item.querySelector('.cart-item__body');
    if (bodyElement) {
      bodyElement.classList.replace('cart-item__body', 'cart-item__kit');
    }
  }
});
  

}

applyClassToCartProperties();
insertKitDividers();





// Função para validar e remover itens com bundle_group se a quantidade total não corresponder a qtdKit
function validateAndRemoveItemsByBundleGroup(event) {
  if (event) event.preventDefault(); // Impede a recarga da página

  // Obtém os itens do carrinho
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const bundleGroups = {};

      // Agrupa itens por bundle_group e verifica qtdKit
      cart.items.forEach(item => {
        if (item.properties && item.properties.bundle_group && item.properties.qtdKit) {
          const bundleGroup = item.properties.bundle_group;
          const qtdKit = parseInt(item.properties.qtdKit, 10);

          if (!bundleGroups[bundleGroup]) {
            bundleGroups[bundleGroup] = { items: [], qtdKit, totalQuantity: 0 };
          }

          bundleGroups[bundleGroup].items.push(item);
          bundleGroups[bundleGroup].totalQuantity += item.quantity;
        }
      });

      // Remove grupos onde a quantidade total não corresponde a qtdKit
      let removalPending = 0; // Contador de itens a remover
      Object.keys(bundleGroups).forEach(bundleGroup => {
        const { items, qtdKit, totalQuantity } = bundleGroups[bundleGroup];

        if (totalQuantity !== qtdKit) {
          console.log(`Quantidade incorreta para ${bundleGroup}. Removendo todos os itens.`);
          removalPending += items.length;
          items.forEach(item => {
            removeItemFromCart(item.key, () => {
              removalPending--;
              if (removalPending === 0) {
                console.log("Todos os itens removidos. Recarga permitida.");
                location.reload(); // Recarrega a página após o último item
              }
            });
          });
        }
      });
    })
    .catch(error => console.error('Erro ao validar itens por bundle_group:', error));
}

validateAndRemoveItemsByBundleGroup();

// Função para remover um item do carrinho com base na sua key
function removeItemFromCart(itemKey, callback) {
  fetch(`/cart/change.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: itemKey, quantity: 0 })
  })
    .then(response => response.json())
    .then(() => {
      console.log(`Item removido com sucesso: ${itemKey}`);
      callback();
    })
    .catch(error => console.error(`Erro ao remover item ${itemKey}:`, error));
}



  // Função auxiliar para encontrar o valor de bundle_group dentro de um cart-item
  function getBundleGroup(cartItem) {
    const options = cartItem.querySelectorAll('.cart-item__option');
    for (let option of options) {
      const label = option.querySelector('div:first-child');
      const value = option.querySelector('div:last-child');
      if (label && label.textContent.trim() === 'bundle_group:') {
        console.log('bundle_group encontrado:', value.textContent.trim());
        return value.textContent.trim();
      }
    }
    console.log('bundle_group não encontrado no item.');
    return null;
  }



  // Função para remover todos os itens com o mesmo "bundle_group"
  function removeItemsWithBundleGroup(bundleGroup) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const bundleItems = cart.items.filter(item => item.properties && item.properties.bundle_group === bundleGroup);
        console.log('Itens encontrados com o bundle_group:', bundleItems); // Log dos itens encontrados

        // Variável para rastrear quantos itens precisam ser removidos
        let itemsToRemove = bundleItems.length;
        let removedItems = 0;

        // Remove cada item que possui o mesmo bundle_group
        bundleItems.forEach((item, index) => {
          console.log('Tentando remover item com key:', item.key); // Log da key do item
          removeItemFromCart(item.key, () => {
            removedItems++;
            // Verifica se todos os itens foram removidos
            if (removedItems === itemsToRemove) {
              console.log('Todos os itens do grupo removidos, recarregando a página');
              setTimeout(() => location.reload(), 1000);

            }
          });
        });
      })
      .catch(error => console.error('Erro ao remover itens do bundle_group:', error));
  }

  // Função para remover um item do carrinho usando a 'key' e chamar o callback após a remoção
  function removeItemFromCart(itemKey, callback) {
    console.log('ID sendo enviado para remoção:', itemKey); // Log do ID/key que está sendo enviado
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0
      })
    })
      .then(response => response.json())
      .then(data => {
        console.log('Resposta da remoção do item do carrinho:', data);
        if (callback) callback(); // Chama o callback após a remoção do item
      })
      .catch(error => {
        console.error('Erro ao remover item do carrinho:', error);
      });
  }

  // Função auxiliar para encontrar o valor de bundle_group dentro de um item
  function getBundleGroup(cartItem) {
    const options = cartItem.querySelectorAll('.cart-item__option');
    for (let option of options) {
      const label = option.querySelector('div:first-child');
      const value = option.querySelector('div:last-child');
      if (label && label.textContent.trim() === 'bundle_group:') {
        return value.textContent.trim();
      }
    }
    return null;
  }

  // Adiciona evento de clique nos botões de remoção
  document.addEventListener('click', function (event) {
    if (event.target.closest('.cart-item__remove-button')) {
      const cartItem = event.target.closest('.cart-item');
      const bundleGroup = getBundleGroup(cartItem); // Obtém o bundle_group do item

      console.log('Bundle group detectado no clique:', bundleGroup); // Log do bundle_group detectado

      // Se o item tiver um "bundle_group", remove todos os itens com o mesmo "bundle_group"
      if (bundleGroup) {
        removeItemsWithBundleGroup(bundleGroup);
      }
    }
  });

  // Função para remover todos os itens com o mesmo "bundle_group"
  function removeItemsWithBundleGroup(bundleGroup) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const bundleItems = cart.items.filter(item => item.properties && item.properties.bundle_group === bundleGroup);

        // Log do número total de itens detectados com o bundle_group
        console.log(`Total de itens detectados com o bundle_group '${bundleGroup}': ${bundleItems.length}`);

        // Variável para rastrear quantos itens precisam ser removidos
        let itemsToRemove = bundleItems.length;
        let removedItems = 0;

        // Remove cada item que possui o mesmo bundle_group
        bundleItems.forEach((item) => {
          removeItemFromCart(item.key, () => {
            removedItems++;
            // Log para cada remoção bem-sucedida
            console.log(`Item com key '${item.key}' removido com sucesso (${removedItems}/${itemsToRemove}).`);

            // Verifica se todos os itens foram removidos
            if (removedItems === itemsToRemove) {
              console.log('Todos os itens do grupo removidos, recarregando a página');
              location.reload(); // Recarrega a página após remover o último item
            }
          });
        });
      })
      .catch(error => console.error('Erro ao remover itens do bundle_group:', error));
  }

  // Função para remover um item do carrinho usando a 'key' e chamar o callback após a remoção
  function removeItemFromCart(itemKey, callback) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0
      })
    })
      .then(response => response.json())
      .then(data => {
        if (callback) callback(); // Chama o callback após a remoção do item
      })
      .catch(error => {
        console.error('Erro ao remover item do carrinho:', error);
      });
  }

  // Função auxiliar para encontrar o valor de bundle_group dentro de um item
  function getBundleGroup(cartItem) {
    const options = cartItem.querySelectorAll('.cart-item__option');
    for (let option of options) {
      const label = option.querySelector('div:first-child');
      const value = option.querySelector('div:last-child');
      if (label && label.textContent.trim() === 'bundle_group:') {
        return value.textContent.trim();
      }
    }
    return null;
  }



  

  // Adiciona evento de clique nos botões de remoção
  document.addEventListener('click', function (event) {
    if (event.target.closest('.cart-item__remove-button')) {
      const cartItem = event.target.closest('.cart-item');
      const bundleGroup = getBundleGroup(cartItem); // Obtém o bundle_group do item

      // Se o item tiver um "bundle_group", remove todos os itens com o mesmo "bundle_group"
      if (bundleGroup) {
        removeItemsWithBundleGroup(bundleGroup);
      }
    }
  });






